<template>
  <div class="drama-home">
    <div class="full-width-banner">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide class="slide slide-1">
          <img src="../assets/images/banner1.jpg" alt="短剧海报1" class="banner-image" />
        </swiper-slide>
        <swiper-slide class="slide slide-2">
          <img src="../assets/images/banner2.jpg" alt="短剧海报2" class="banner-image" />
        </swiper-slide>
        <swiper-slide class="slide slide-3">
          <img src="../assets/images/banner3.jpg" alt="短剧海报3" class="banner-image" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>

    <div class="container">
      <section class="hero panel reveal">
        <div class="hero-copy">
          <p class="tag">短剧内容平台</p>
          <h1>更好看、更丰富、更新更快的短剧体验</h1>
        <p class="desc">
          面向短剧场景，我们提供从内容策划、制作到分发的完整能力，
          重点打造高质量内容、丰富片库供给和稳定上新节奏，持续提升用户追剧粘性。
        </p>
      </div>
      <div class="hero-data">
        <div class="data-card">
          <span class="number">内容质量</span>
          <span class="label">围绕剧情节奏、人物塑造与画面质感建立统一质量标准</span>
        </div>
        <div class="data-card">
          <span class="number">片库数量</span>
          <span class="label">持续扩充多题材片库，满足不同用户在不同时段的观看需求</span>
        </div>
        <div class="data-card">
          <span class="number">新品上新</span>
          <span class="label">保持稳定更新频率，通过新剧与新题材不断制造追更期待</span>
        </div>
      </div>
    </section>

    <section class="genres reveal">
      <div class="section-head">
        <p>内容方向</p>
        <h2>短剧的多元题材供给</h2>
      </div>
      <div class="genre-grid">
        <article class="genre-item">
          <h3>都市甜燃</h3>
          <p>高糖关系 + 职场成长，适配女性向高活跃人群。</p>
        </article>
        <article class="genre-item">
          <h3>古风逆袭</h3>
          <p>身份反转 + 权谋爽点，兼顾服化道视觉传播力。</p>
        </article>
        <article class="genre-item">
          <h3>悬疑推理</h3>
          <p>每集留钩子，强化追更驱动和社区讨论热度。</p>
        </article>
        <article class="genre-item">
          <h3>奇幻脑洞</h3>
          <p>设定先行，适合品牌定制共创与世界观联名。</p>
        </article>
        <article class="genre-item">
          <h3>现实话题</h3>
          <p>聚焦代际、婚恋、职场议题，具备破圈潜力。</p>
        </article>
      </div>
    </section>

    <section class="lineup panel reveal">
      <div class="section-head">
        <p>平台能力</p>
        <h2>围绕质量、数量与上新的运营体系</h2>
      </div>
      <div class="lineup-list">
        <div class="lineup-item">
          <p class="title">质量保障机制</p>
          <p class="meta">通过选题评审、剧本打磨和成片复核，保证内容体验稳定在线。</p>
        </div>
        <div class="lineup-item">
          <p class="title">片库分层运营</p>
          <p class="meta">按题材与人群偏好进行内容分层，提升触达效率与点击转化。</p>
        </div>
        <div class="lineup-item">
          <p class="title">新品孵化计划</p>
          <p class="meta">结合热点趋势推进新题材测试和新品上线，保持平台内容新鲜度。</p>
        </div>
      </div>
    </section>

    <section class="cta reveal">
      <h2>打造更有竞争力的短剧内容生态</h2>
      <p>支持内容共创、平台合作与商业联动，帮助项目实现长期稳定增长。</p>
    </section>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: "HomeView",
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
};
</script>

<style>
/* 覆盖父级设置的内容区内边距，让轮播图可以顶边 */
.site-main {
  padding-top: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>

<style scoped>
.drama-home {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 36px;
  padding-bottom: 26px;
}

.full-width-banner {
  width: 100%;
  height: 80vh;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-button-prev,
.swiper-button-next {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: 20px;
}

.slide {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #11212b; /* 占位色 */
  position: relative;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.container {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  display: grid;
  gap: 26px;
  padding: 0 24px;
}

.panel {
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 20px;
  background: rgba(7, 14, 20, 0.72);
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.3);
}

.hero {
  padding: 32px;
  display: grid;
  gap: 22px;
  grid-template-columns: 1.25fr 1fr;
}

.hero-copy {
  display: grid;
  align-content: start;
  gap: 8px;
}

.tag {
  margin: 0;
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #ffb684;
}

h1 {
  margin: 14px 0;
  font-size: clamp(34px, 5vw, 56px);
  line-height: 1.08;
}

.desc {
  margin: 0;
  max-width: 620px;
  line-height: 1.7;
  color: rgba(236, 245, 250, 0.82);
}

.btn {
  border: 0;
  padding: 12px 18px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.btn-solid {
  color: #fff;
  background: linear-gradient(110deg, #ff6f2c, #ff9259);
}

.hero-data {
  display: grid;
  gap: 12px;
  align-content: center;
}

.data-card {
  padding: 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.number {
  display: block;
  font-size: 30px;
  font-weight: 800;
}

.label {
  color: rgba(236, 245, 250, 0.75);
  font-size: 13px;
}

.genres,
.lineup,
.cta {
  padding: 26px;
}

.section-head p {
  margin: 0;
  color: #ffb684;
  letter-spacing: 0.1em;
  font-size: 12px;
  text-transform: uppercase;
}

.section-head h2 {
  margin: 10px 0 18px;
  font-size: clamp(24px, 3vw, 34px);
}

.genre-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.genre-item {
  padding: 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.genre-item h3 {
  margin: 0 0 8px;
  font-size: 16px;
}

.genre-item p,
.lineup-item .meta,
.cta p {
  margin: 0;
  line-height: 1.7;
  color: rgba(236, 245, 250, 0.78);
}

.lineup-list {
  display: grid;
  gap: 12px;
}

.lineup-item {
  padding: 16px;
  border-radius: 14px;
  background: linear-gradient(120deg, rgba(255, 111, 44, 0.12), rgba(255, 255, 255, 0.06));
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.lineup-item .title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
}

.cta {
  border-radius: 20px;
  text-align: center;
  background: linear-gradient(120deg, rgba(255, 111, 44, 0.18), rgba(10, 40, 60, 0.84));
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.cta h2 {
  margin-top: 0;
}

.cta .btn {
  margin-top: 14px;
}

.reveal {
  opacity: 0;
  transform: translateY(20px);
  animation: rise 0.7s ease forwards;
}

.reveal:nth-child(2) {
  animation-delay: 0.1s;
}

.reveal:nth-child(3) {
  animation-delay: 0.2s;
}

.reveal:nth-child(4) {
  animation-delay: 0.3s;
}

@keyframes rise {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1060px) {
  .hero {
    grid-template-columns: 1fr;
  }

  .genre-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .hero,
  .genres,
  .lineup,
  .cta {
    padding: 22px;
  }

  .genre-grid {
    grid-template-columns: 1fr;
  }
}
</style>
